import React, { useEffect, useRef, useState } from 'react';

interface DeleteRunDialogProps {
  runIds: string[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteRunDialog: React.FC<DeleteRunDialogProps> = ({
  runIds,
  onConfirm,
  onCancel,
}) => {
  const [input, setInput] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 8,
          padding: 24,
          width: 420,
          maxWidth: '90vw',
        }}
      >
        <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8, color: 'var(--danger)' }}>
          Delete {runIds.length === 1 ? 'Run' : `${runIds.length} Runs`}
        </div>
        <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 4 }}>
          {runIds.length === 1
            ? 'This will permanently delete run'
            : 'This will permanently delete the following runs:'}
        </div>
        {runIds.length === 1 ? (
          <div
            style={{
              fontFamily: 'var(--font-mono)',
              fontSize: 11,
              color: 'var(--text-primary)',
              marginBottom: 12,
              wordBreak: 'break-all',
            }}
          >
            {runIds[0]}
          </div>
        ) : (
          <div
            style={{
              fontFamily: 'var(--font-mono)',
              fontSize: 11,
              color: 'var(--text-primary)',
              marginBottom: 12,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            {runIds.map((id) => (
              <div key={id} style={{ wordBreak: 'break-all' }}>
                {id}
              </div>
            ))}
          </div>
        )}
        <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 16 }}>
          {runIds.length === 1 ? 'and all of its run samples.' : 'and all of their run samples.'}{' '}
          This action cannot be undone.
        </div>
        <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>
          Type <strong style={{ color: 'var(--text-primary)' }}>DELETE</strong> to confirm:
        </div>
        <input
          ref={inputRef}
          className="eval-form-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && input === 'DELETE') onConfirm();
          }}
          placeholder="DELETE"
          style={{ marginBottom: 16, fontFamily: 'var(--font-mono)' }}
        />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="eval-btn-ghost" onClick={onCancel}>
            Cancel
          </button>
          <button className="eval-btn-danger" disabled={input !== 'DELETE'} onClick={onConfirm}>
            Delete {runIds.length === 1 ? 'Run' : `${runIds.length} Runs`}
          </button>
        </div>
      </div>
    </div>
  );
};
